import {Container, Nav, Navbar} from 'react-bootstrap';
import Offcanvas from 'react-bootstrap/Offcanvas';
import logo from '../../../images/sepidar_logo_small.png';
import {Link} from 'react-router-dom';
import {Body} from '../Body/Body';
import {useState} from 'react';

export const Header = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleToggle = () => setShow((prevShow) => !prevShow);
  return (
    <>
    <Navbar key={'md'} variant="light" bg='light' expand={'md'} className="mb-3">
      <Container>
        <Navbar.Brand style={{fontWeight: 'bold'}} as={Link} to="/"><img
          style={{width: '50px', marginRight: '20px', marginBottom: '10px'}} src={logo} alt="Logo"/>Sepidar
          Theater</Navbar.Brand>
        <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-md`} onClick={handleToggle}/>
        <Navbar.Offcanvas
          show={show}
          id={`offcanvasNavbar-expand-md`}
          aria-labelledby={`offcanvasNavbarLabel-expand-md`}
          placement="end"
        >
          <Offcanvas.Header closeButton className='align-items-start' onClick={handleToggle}>
            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-md`}>
              <Nav.Link as={Link} to="/">
                <img style={{width: '150px', marginRight: '20px', marginBottom: '10px'}} src={logo} alt="Logo"/>
              </Nav.Link>

            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className='mt-5 mt-md-0'>
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/about" onClick={handleClose}>Über uns</Nav.Link>
              <Nav.Link as={Link} to="/projects" onClick={handleClose}>Projekte</Nav.Link>
              <Nav.Link as={Link} to="/contact" onClick={handleClose}>Kontakt</Nav.Link>
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
    <Body/>
  </>)
}
